import { Box } from "@mui/material";
import StatusIcon from "../../../../../../../shared/components/StatusLabel/StatusIcon";
import MessagePreviewScreen from "../../../../../../../shared/components/common/ui/MessagePreviewScreen/MessagePreviewScreen";

const TemplatesPreview = ({ templateType, preview }) => {
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: { xs: 300, lg: "auto" },
        px: 2,
      }}
    >
      {templateType === "E-mail" ? (
        <Box
          borderRadius="12px"
          border="1px solid #A986FF"
          overflow="hidden"
          bgcolor="#fff"
          sx={{
            width: "100%",
            maxWidth: 630,
            flexShrink: 0,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            padding="12px"
            sx={{ backgroundColor: "#8142FC", color: "#fff" }}
          >
            <StatusIcon
              status="E-mail"
              height="26px"
              width="26px"
              color="#fff"
            />
          </Box>

          <Box padding="20px">
            <MessagePreviewScreen
              disabledButtons={true}
              channel={preview.channel}
              messages={preview.messages}
              readOnly
            />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            maxWidth: 420,
            flexShrink: 0,
          }}
        >
          <MessagePreviewScreen
            disabledButtons={true}
            channel={preview.channel}
            messages={preview.messages}
            readOnly
          />
        </Box>
      )}
    </Box>
  );
};

export default TemplatesPreview;
